import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';
import { withTranslation } from 'react-i18next';
class DropdownButton extends Component {
    constructor(props) {
        super(props);
        this.state = {
            item: {},
        };
    }
    handleClick(e) {
        const code = e.target.value;
        const item = _.findWhere(this.props.items, { value: code });
        if (!item)
            console.log('Selected item not found in items!');
        this.setState({ item }, () => {
            this.props.onSelect(item);
        });
    }
    render() {
        const { placeholder, items, title, disabled, t } = this.props;
        const selected = items.find((item) => item.value === title);
        return (React.createElement("select", { onChange: (e) => this.handleClick(e), placeholder: placeholder || t('SELECT_A_VALUE'), className: "w-full mb-4 form-select", value: selected ? selected.value : null, disabled: disabled }, items.map((item) => {
            return (React.createElement("option", { key: item.value, value: item.value }, t(item.localizationSlug) || item.display || item.name));
        })));
    }
}
DropdownButton.propTypes = {
    items: PropTypes.array.isRequired,
    onSelect: PropTypes.func.isRequired,
    title: PropTypes.string,
    placeholder: PropTypes.string,
    disabled: PropTypes.bool,
};
export default withTranslation()(DropdownButton);
